module.exports = __webpack_public_path__ + "static/media/america-puebla.dcd4a190.mp4";